import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { streckenTarifierungThhPferd } from './streckenTarifierungThhPferd';
import { shopTarifierungThhPferd } from './shopTarifierungThhPferd';
import { watchProduktlinienSaga } from './produktlinienSaga';
import { watchInDashboardUebernehmenSaga } from './inDashboardUebernehmenSaga';
import { watchVersicherungssummen } from './versicherungssummenSaga';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchDruckdatenChanged } from './druckdatenSaga';
import { watchVorbelegungRequested } from './vorbelegungSagaPferd';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchVorschlagdatenChanged } from './vorschlagdatenSaga';
import { watchQuoteDB } from './quoteDbSaga';
import { handleThhPferdNavigationToAngebotSaga } from './handleThhPferdNavigationToAngebotSaga';

export function* rootSaga() {
  yield all([
    watchStateSnapshot(),
    watchStreckeSnapshot(),
    streckenTarifierungThhPferd(),
    watchVorbelegungRequested(),
    shopTarifierungThhPferd(),
    watchProduktlinienSaga(),
    watchInDashboardUebernehmenSaga(),
    watchVersicherungssummen(),
    watchAntragsnummerRequested(),
    watchDruckdatenChanged(),
    watchVorschlagdatenChanged(),
    watchQuoteDB(),
    handleThhPferdNavigationToAngebotSaga(),
  ]);
}
